/**
 * MOCK · ASSUMED — what the Knowledge mocks share (CT-5717 Drive, CT-5718
 * Sandbox), in one place so neither imports the other's internals:
 *
 * - the QA switch, read from the URL on every request (`?mockKnowledge=…`):
 *
 *     empty         the folder in view / the Sandbox has nothing
 *     fail          the drive / the Sandbox fails to load
 *     readonly      the viewer may not manage the drive (no New folder, no toggle)
 *     create_fail   creating a folder fails
 *     action_fail   confirming, sending or resolving a Sandbox claim fails
 *
 * - the dates of the files a Sandbox group IS (a call transcript, a QBR), so
 *   Drive and Sandbox date them alike. The claims each file holds are the
 *   Sandbox's own; Drive counts them from there (`countMockSandboxClaimsByFile`).
 */

export const KNOWLEDGE_SCENARIOS = Object.freeze(['empty', 'fail', 'readonly', 'create_fail', 'action_fail']);

let scenarioOverride = null;

export const getMockKnowledgeScenario = () => {
  if (scenarioOverride) return scenarioOverride;
  try {
    const value = new URLSearchParams(window.location.search).get('mockKnowledge');
    return KNOWLEDGE_SCENARIOS.includes(value) ? value : null;
  } catch {
    return null;
  }
};

export const __setMockKnowledgeScenario = (value) => {
  scenarioOverride = value;
};

/** The prototype's dates (record PER-0104) of the files Sandbox groups by. */
export const KNOWLEDGE_FILE_DATES = Object.freeze({
  'file-call-transcript': '2026-09-02T15:00:00Z',
  'file-qbr': '2026-08-26T15:00:00Z',
  'file-access-log': '2026-07-24T15:00:00Z',
});
